import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Input from "../../../form-components/Input";
import { useDispatch, useSelector } from "react-redux";
import { getUserList } from "../../../../features/userManagement/getUserListSlice";
import Button from "../../../form-components/Button";
import { getUserRoleList } from "../../../../features/userManagement/getUserRolesSlice";

const ShareDocumentAccessModal = ({
  isOpen,
  toggle,
  selectedType,
  setSelectedType,
  selectedData,
  setSelectedData,
  selectedtypeSearch,
  setSelectedTypeSearch,
  values,
  index,
  setFieldValue,
  onSaveAccessClick,
  isAllChecked,
  setIsAllChecked,
  inviteOnlyData,
}) => {
  const { userList, userRoles } = useSelector((state) => ({
    userRoles: state?.getUserRoleListReducer?.responseData?.role,
    userList: state?.getUserListReducer?.responseData?.users,
  }));
  const dispatch = useDispatch();
  let projectData = JSON.parse(localStorage.getItem("_user"));

  useEffect(() => {
    dispatch(
      getUserList({
        perPage: 1000,
        page: 1,
        search: selectedtypeSearch,
        isActive: 1,
        organization_uuid: projectData?.organizations[0].uuid,
      })
    );
    dispatch(
      getUserRoleList({
        perPage: 100,
        page: 1,
        search: selectedtypeSearch,
        is_active: 1,
        organisation_uuid: projectData?.organizations[0].uuid,
      })
    );
    if (inviteOnlyData.inviteOnly) {
      if (inviteOnlyData?.inviteOnly[index]?.access_role.length > 0) {
        setSelectedType("role");
      } else {
        setSelectedType("user");
      }
    }
  }, [selectedtypeSearch]);

  useEffect(() => {
    if (inviteOnlyData.inviteOnly) {
      if (inviteOnlyData?.inviteOnly[index]?.access_role.length > 0) {
        if (
          inviteOnlyData?.inviteOnly[index]?.access_role.length ===
          userRoles?.length
        ) {
          setIsAllChecked(true);
        }
      } else {
        if (
          inviteOnlyData?.inviteOnly[index]?.access_user.length ===
          userList?.length
        ) {
          setIsAllChecked(true);
        }
      }
    }
  }, [userList, userRoles]);

  const onCheckboxChange = (e, id, setFieldValue) => {
    if (!e.target.checked) {
      setSelectedData(selectedData.filter((d) => d !== id));
      setIsAllChecked(false);
      selectedType === "user"
        ? setFieldValue(
            `inviteOnly[${index}].access_user`,
            values?.inviteOnly[index].access_user.filter((d) => d !== id)
          )
        : setFieldValue(
            `inviteOnly[${index}].access_role`,
            values?.inviteOnly[index].access_role.filter((d) => d !== id)
          );
    } else {
      const newAccessUser = id;

      const updatedInviteOnly = [...values.inviteOnly];
      if (selectedType === "user") {
        updatedInviteOnly[index] = {
          ...updatedInviteOnly[index],
          access_user: [...updatedInviteOnly[index].access_user, newAccessUser],
        };
      } else {
        updatedInviteOnly[index] = {
          ...updatedInviteOnly[index],
          access_role: [...updatedInviteOnly[index].access_role, newAccessUser],
        };
      }
      const updatedValues = {
        ...values,
        inviteOnly: updatedInviteOnly,
      };
      // selectedType === "user"
      //   ? values?.inviteOnly[index].access_user.push(id)
      //   : values?.inviteOnly[index].access_role.push(id);
      selectedType === "user"
        ? setFieldValue(
            `inviteOnly.[${index}].access_user`,
            updatedValues?.inviteOnly[index].access_user
          )
        : setFieldValue(
            `inviteOnly.[${index}].access_role`,
            updatedValues?.inviteOnly[index].access_role
          );
      setSelectedData(selectedData);
    }
  };

  const selectAllClick = (e, setFieldValue) => {
    let uuids =
      selectedType === "user"
        ? userList.map((d) => d?.uuid)
        : userRoles.map((d) => d?.uuid);
    if (!e.target.checked) {
      setIsAllChecked(false);
      selectedType === "user"
        ? setFieldValue(`inviteOnly[${index}].access_user`, [])
        : setFieldValue(`inviteOnly[${index}].access_role`, []);
    } else {
      setIsAllChecked(true);
      selectedType === "user"
        ? setFieldValue(`inviteOnly[${index}].access_user`, uuids)
        : setFieldValue(`inviteOnly[${index}].access_role`, uuids);
    }
  };

  return (
    <>
      <Modal
        className="add-document-popup share-doc-modal"
        show={isOpen}
        onHide={toggle}
        backdrop="static"
        dialogClassName="common-modal modal-dialog-centered"
      >
        <Modal.Header className="border-0" closeButton>
          <h3 className="modal-title">
            Select {selectedType == "user" ? "User" : "Role"}
          </h3>
        </Modal.Header>
        <Modal.Body className="pb-4 mb-2">
          <div className="access-role-radio">
            <div className="form-check d-inline-block">
              <Input
                className="form-check-input"
                name="radoch"
                checked={selectedType === "user"}
                type="radio"
                value="user"
                id="radion1"
                onChange={(e) => {
                  setSelectedType(e.target.value);
                  setSelectedData([]);
                  setSelectedTypeSearch("");
                  setFieldValue(`inviteOnly[${index}].access_role`, []);
                  setIsAllChecked(false);
                }}
              />
              <label className="form-check-label" htmlFor="radion1">
                Users
              </label>
            </div>
            <div className="form-check d-inline-block">
              <Input
                className="form-check-input"
                type="radio"
                checked={selectedType === "role"}
                name="radoch"
                value="role"
                id="radion2"
                onChange={(e) => {
                  setSelectedType(e.target.value);
                  setSelectedData([]);
                  setSelectedTypeSearch("");
                  setFieldValue(`inviteOnly[${index}].access_user`, []);
                  setIsAllChecked(false);
                }}
              />
              <label className="form-check-label" htmlFor="radion2">
                Role
              </label>
            </div>
          </div>
          <div className="intro-searchbar">
            <Button
              disabled
              type="button"
              className="filter-search-btn"
            ></Button>
            <Input
              type="text"
              className="form-control"
              name="search"
              placeholder="Search"
              value={selectedtypeSearch}
              onChange={(e) => setSelectedTypeSearch(e.target.value)}
            />
            {selectedtypeSearch.length > 0 && (
              <button
                type="button"
                class="btn search-reset-btn"
                onClick={() => setSelectedTypeSearch("")}
              >
                <svg
                  class="close-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="13.414"
                  height="13.414"
                  viewBox="0 0 13.414 13.414"
                >
                  <g
                    id="Group_31758"
                    data-name="Group 31758"
                    transform="translate(0.707 0.707)"
                  >
                    <path
                      id="Path_48155"
                      data-name="Path 48155"
                      d="M0,0,12,12"
                      fill="none"
                      stroke="#313b5c"
                      stroke-width="2"
                    ></path>
                    <path
                      id="Path_48154"
                      data-name="Path 48154"
                      d="M12,0,0,12"
                      fill="none"
                      stroke="#313b5c"
                      stroke-width="2"
                    ></path>
                  </g>
                </svg>
              </button>
            )}
          </div>
          <div className="row">
            <div className="col-12 col-md-12 col-lg-7">
              <p className="fw-500 color-primary">
                Select {selectedType == "user" ? "User" : "Role"}
                <span className="share-form-color-gray fw-400">
                  (
                  {selectedType === "user"
                    ? values?.inviteOnly[index].access_user.length
                    : values?.inviteOnly[index].access_role.length}{" "}
                  selected)
                </span>
              </p>
            </div>
            <div className="col-12 col-md-12 col-lg-5 text-start text-lg-end mt-3 mt-lg-0">
              <div className="form-check d-inline-block">
                <input
                  checked={isAllChecked}
                  className="form-check-input"
                  type="checkbox"
                  value={isAllChecked}
                  id="flexCheckDefault"
                  onChange={(e) => selectAllClick(e, setFieldValue)}
                />
                <label
                  className="form-check-label fw-500"
                  htmlFor="flexCheckDefault"
                >
                  Select All
                </label>
              </div>
            </div>
          </div>
          <div className="label-list slect-role-scroll">
            {selectedType === "user" &&
              (userList?.length > 0 ? (
                userList.map((user, idx) => {
                  return (
                    <div className="slect-role-list" key={idx}>
                      <Input
                        checked={
                          isAllChecked === true
                            ? isAllChecked
                            : values?.inviteOnly[index].access_user.includes(
                                user?.uuid
                              )
                        }
                        className="form-check-input"
                        type="checkbox"
                        name={`inviteOnly[${index}].access_user`}
                        id={`flexCheckDefault${idx}`}
                        value={`${values?.inviteOnly[index].access_user}`}
                        onChange={(e) =>
                          onCheckboxChange(e, user.uuid, setFieldValue)
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`flexCheckDefault${idx}`}
                      >
                        {user?.first_name} {user?.last_name}
                      </label>
                    </div>
                  );
                })
              ) : (
                <div className="d-flex justify-content-center">
                  No user found
                </div>
              ))}
            {selectedType === "role" &&
              (userRoles?.length > 0 ? (
                userRoles.map((role, idx) => {
                  return (
                    <div className="slect-role-list" key={idx}>
                      <Input
                        checked={
                          isAllChecked === true
                            ? isAllChecked
                            : values?.inviteOnly[index].access_role.includes(
                                role?.uuid
                              )
                        }
                        className="form-check-input"
                        type="checkbox"
                        name={`inviteOnly[${index}].access_role`}
                        id={`flexCheckDefault${idx}`}
                        value={`${values?.inviteOnly[index].access_role}`}
                        onChange={(e) =>
                          onCheckboxChange(e, role.uuid, setFieldValue)
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`flexCheckDefault${idx}`}
                      >
                        {role?.name}
                      </label>
                    </div>
                  );
                })
              ) : (
                <div className="d-flex justify-content-center">
                  No role found
                </div>
              ))}

            {/* <div className='sub-label-menu'>
              <div className="form-check">
                <input className="form-check-input" type="checkbox" value="" id="sublabel1" />
                <label className="form-check-label color-primary" htmlFor="sublabel1">
                  Media Relations
                </label>
              </div>
              <div className="form-check">
                <input className="form-check-input" type="checkbox" value="" id="sublabel3" />
                <label className="form-check-label color-primary" htmlFor="sublabel3">
                  Event Management
                </label>
              </div>
              <div className="form-check">
                <input className="form-check-input" type="checkbox" value="" id="sublabel4" />
                <label className="form-check-label color-primary" htmlFor="sublabel4">
                  Advertising Campaigns
                </label>
              </div>
            </div> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            className="btn btn-primary-md"
            onClick={onSaveAccessClick}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ShareDocumentAccessModal;
